<template>
   <dashboard-layout>
       <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                <!-- <input type="search" class="form-control" placeholder="Search"> -->
                <span class="input-group-btn">
                    <!-- <button class="btn"><i class="fa fa-search"></i></button> -->
                </span><!-- input-group-btn -->
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <!-- <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div> -->
                <div class="sh-pagetitle-title"> 
                    <h2>Klanten</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div class="row row-sm">
                    <div class="card bd-primary col-12  mg-t-20">
                        <div class="card-header bg-primary tx-white">
                            <a href="/create-debtor" class="float-right btn btn-success">
                                <i class="fa fa-plus"></i> Klant aanmaken
                            </a>
                        </div>
                        <div class="card-body pd-sm-30">
                            <div class="table-wrapper">
                            <table id="datatable2" class="table table-striped table-bordered display responsive nowrap">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Naam</th>
                                        <th>Email</th>
                                        <th>Telefoonnummer</th>
                                        <th>Adres</th>
                                        <th>Huisnummer</th>
                                        <th>Postcode</th>
                                        <th>Plaats</th>
                                        <th>Land</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <button @click="search()" class="btn btn-success"><i class="fa fa-search"></i></button>
                                        </td>
                                        <td v-for="(item,index) in attrlist" :key="index">
                                            <input type="text" v-model="attr[index].value" v-on:keyup.enter="search">
                                        </td>
                                    </tr>
                                    <tr v-if="loading.status">
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <div class="" >
                                                <div class="d-flex pos-relative align-items-center">
                                                    <div style="margin:0px" class="sk-rotating-plane bg-gray-800"></div>
                                                </div>
                                            </div>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(item,index) in debtors" :key="index">
                                        <td>
                                            <a  :href="'/edit-debtor/'+item.id" class="btn btn-warning"><i class="fa fa-edit"></i></a>
                                        </td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.email}}</td>
                                        <td>{{item.phonenumber}}</td>
                                        <td>{{item.address}}</td>
                                        <td>{{item.address_number}}</td>
                                        <td>{{item.zipcode}}</td>
                                        <td>{{item.city}}</td>
                                        <td>{{item.country}}</td>  
                                    </tr>
                                </tbody>
                            </table>
                            </div><!-- table-wrapper -->
                        </div><!-- card-body -->
                    </div> 
                </div>
            </div>
       </div>
   </dashboard-layout>
</template>

<script>
import dashboardLayout from '../layouts/dashboard_layout'

import { mapState } from 'vuex'
export default {
    name:'orders',
    components:{
        dashboardLayout
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        })
    },
    data(){
        return {
            debtors:[],
            order_id:0, 
            attr:[
                {
                    attribute:'name',
                    value:''
                },
                {
                    attribute:'email',
                    value:''
                },
                {
                    attribute:'phonenumber',
                    value:''
                },
                {
                    attribute:'address',
                    value:''
                },
                {
                    attribute:'address_number',
                    value:''
                },
                {
                    attribute:'zipcode',
                    value:''
                },
                {
                    attribute:'city',
                    value:''
                },
                {
                    attribute:'country',
                    value:''
                },
            ],
            attrlist:['name','address',
                'address_number',
                'zipcode','city','country',
                'phonenumber','email',
            ]
        }
    },
    created(){
        this.$store.state.loading.status=true;
        this.$store.dispatch('get',this.endpoint+'vue/organizations')
        .then((data)=>{
            console.log(data);
            this.debtors=data.data; 
            setTimeout(()=>{
                window.$("#dataTable2").DataTable();
            },500);
            this.$store.state.loading.status=false; 
        })
        .catch((error)=>{
            console.log(error.request);
            this.$store.state.loading.status=false;
        })
    },
    mounted(){ 
    },
    methods:{ 
        search(){
            if(this.$store.state.loading.status){
                return false;
            }
            console.log('search', this.attr);
            
            this.$store.state.loading.status=true; 
             this.$store.dispatch('post',{
                details:{search:this.attr},
                endpoint:this.endpoint+'vue/organizations/search' 
             })
            .then((data)=>{
                console.log(data);
                 this.debtors=data.data;
                this.$store.state.loading.status=false; 
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            })
        },
        createOrder(){  
            this.$store.state.loading.status=true;
            this.$store.dispatch('post',{details:{order_id:this.order_id},endpoint:this.endpoint+'vue/order/'+this.order_id})
            .then((data)=>{
                console.log(data);
                this.$store.state.loading.status=false;
                window.location.href="edit-order/"+data.data.id;
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            });
        },
        deleteItem(id){
            if(!confirm('Are you sure you want to delete this item')){
                return false;
            }
            this.orders=this.orders.filter((d)=> d.id != id);
            
            this.$store.dispatch('post',{details:'',endpoint:this.endpoint+'vue/orders/'+id+'/delete'})
            .then((data)=>{
                console.log('delete',data); 
            })
            .catch((error)=>{
                console.log(error.request);
            });

        }
    }
}
</script>